// extracted by mini-css-extract-plugin
export var downArrow = "_8b-0";
export var label = "_8b-1";
export var treatmentCard = "_8b-3";
export var upArrow = "_8b-2";